module.exports = __webpack_public_path__ + "static/media/vtex23.7214498d.png";